'use strict';

const navigation = [
  '$rootScope',
  '$window',
  'breakpoint',
  'scrollTop',

  function ($rootScope, $window, breakpoint, scrollTop) {
    var windowEl = angular.element($window);
    var navigationThreshold;
    var addedClass;
    var navigationEl;
    let isListening;
    breakpoint = breakpoint();

    function checkScrollPosition() {
      if (scrollTop() >= navigationThreshold[breakpoint]) {
        navigationEl.removeClass(addedClass);
      } else {
        navigationEl.addClass(addedClass);
      }

      $rootScope.$emit('navigation');
    }

    function addEventListener() {
      windowEl.on('scroll', checkScrollPosition);
    }

    function removeEventListener() {
      windowEl.off('scroll', checkScrollPosition);
    }

    function removeClass() {
      navigationEl.removeClass(addedClass);
      removeEventListener();
      isListening = false;

      addedClass = null;
      navigationThreshold = null;
    }


    function addClass(cssClass, threshold) {
      removeClass();

      addedClass = cssClass;
      navigationThreshold = threshold;

      if (addedClass && navigationThreshold) {
        isListening = true;
        addEventListener();
        checkScrollPosition();
      }
    }

    $rootScope.$on('$stateChangeSuccess', function (event, newState) {
      var newStateData = newState.data || {};

      if (navigationEl) {
        addClass(newStateData.navigationCssClass, newStateData.navigationScrollThreshold);
      }
      $rootScope.$emit('navigation');
    });

    $rootScope.$on('breakpointChanged', function (event, newBreakpoint) {
      breakpoint = newBreakpoint;

      if (navigationThreshold) {
        checkScrollPosition();
      }
    });

    return {
      setNavigationElement: function (element) {
        navigationEl = element;
      },

      setScrollThresholdAndClass: addClass,

      unsetScrollThresholdAndClass: removeClass,

      isFixed: function () {
        return $window.getComputedStyle(navigationEl[0], null).getPropertyValue('position') === 'fixed';
      },

      getElement: function () {
        return navigationEl;
      },

      disable: function () {
        navigationEl.addClass('is-disabled');
        if (isListening) {
          removeEventListener();
        }
      },

      enable: function () {
        navigationEl.removeClass('is-disabled');
        if (isListening) {
          checkScrollPosition();
          addEventListener();
        }
      }
    };
  }
];

export default navigation;



// WEBPACK FOOTER //
// ./app/src/services/navigation.js